document.addEventListener(
  'click',
  function (event) {
    const swatch = event.target.closest('[data-card-swatch]');

    if (!swatch) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const productCard =
      swatch.closest('.product-card-wrapper') ||
      swatch.closest('.card-wrapper');

    if (!productCard) return;

    const variantImage = swatch.dataset.variantImage;
    const variantSrcset = swatch.dataset.variantImageSrcset;
    const variantUrl = swatch.dataset.variantUrl;

    /*
     * Do nothing when the variant has no assigned image.
     * Do not unexpectedly redirect the customer.
     */
    if (!variantImage) {
      console.warn(
        'No variant image assigned for variant:',
        swatch.dataset.variantId
      );
      return;
    }

    const cardMedia = productCard.querySelector('.card__media');

    if (!cardMedia) return;

    const images = cardMedia.querySelectorAll('img');

    if (!images.length) return;

    /*
     * Update the primary product-card image.
     */
    const primaryImage = images[0];

    primaryImage.src = variantImage;

    if (variantSrcset) {
      primaryImage.srcset = variantSrcset.trim();
    } else {
      primaryImage.removeAttribute('srcset');
    }

    primaryImage.removeAttribute('data-src');
    primaryImage.removeAttribute('data-srcset');

    /*
     * Prevent Dawn's secondary hover image from covering
     * the newly selected variant image.
     */
    if (images.length > 1) {
      images[1].src = variantImage;

      if (variantSrcset) {
        images[1].srcset = variantSrcset.trim();
      } else {
        images[1].removeAttribute('srcset');
      }

      images[1].removeAttribute('data-src');
      images[1].removeAttribute('data-srcset');
    }

    /*
     * Update product-card links to the selected variant.
     */
    if (variantUrl) {
      productCard
        .querySelectorAll('.card__heading a, .card__media a')
        .forEach(function (link) {
          link.href = variantUrl;
        });
    }

    /*
     * Update selected swatch styling.
     */
    productCard
      .querySelectorAll('[data-card-swatch]')
      .forEach(function (item) {
        item.classList.remove('is-selected');
        item.removeAttribute('aria-current');
      });

    swatch.classList.add('is-selected');
    swatch.setAttribute('aria-current', 'true');
  },
  true
);

/* ==========================================================================
   Fallback swatches for products with very many variants
   --------------------------------------------------------------------------
   Liquid only exposes the first 250 variants, so on collection cards the
   swatch snippet can come back empty for big products (e.g. 14 colors x 5 x 12).
   For every product card that did not get swatches from Liquid, read the
   product's options from /products/<handle>.js and draw the same swatches.
   Cards that already have swatches are left alone.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__cardSwatchFallback) return;
  window.__cardSwatchFallback = true;

  var MAX_SWATCHES = 5;

  // Approximate swatch colors by color name (edit freely; keys are lower-case)
  var COLORS = {
    'black': '#000000', 'white': '#ffffff', 'off white': '#f3efe6', 'cream': '#f5ecd7',
    'navy': '#1b2a8c', 'navy blue': '#1b2a8c', 'beige': '#e8d5a8', 'skin': '#e8c3a4',
    'brown': '#7b4a26', 'coffee': '#6f4e37', 'purple': '#6a2c91', 'lilac': '#c8a2c8',
    'baby pink': '#f4b6c2', 'pink': '#f4a6b8', 'shocking pink': '#f0258c',
    'olive': '#808000', 'olive green': '#808000', 'bottle green': '#0b5d3b', 'green': '#2e7d32',
    'sky blue': '#6fa8f0', 'mid blue': '#4a7fc1', 'light blue': '#a9c9ea', 'blue': '#2f5fbf',
    'mustard': '#e0a31b', 'lemon yellow': '#f7e04b', 'yellow': '#f2d024',
    'maroon': '#800000', 'red': '#c1121f', 'wine': '#722f37',
    'grey': '#9a9a9a', 'gray': '#9a9a9a', 'dark grey': '#555555', 'light grey': '#cfcfcf', 'charcoal': '#36454f',
    'khaki': '#c3b091', 'rust': '#b7410e', 'peach': '#ffcba4', 'mint': '#a8e6cf'
  };

  var cache = {};

  function colorFor(name) {
    var key = String(name).toLowerCase().replace(/\s+/g, ' ').trim();
    if (COLORS[key]) return COLORS[key];
    var compact = key.replace(/\s+/g, '');
    if (window.CSS && CSS.supports && CSS.supports('color', compact)) return compact;
    return '#cccccc';
  }

  function loadProduct(path) {
    if (!cache[path]) {
      cache[path] = fetch(path + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[path];
  }

  function productPath(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var m = new URL(link.getAttribute('href'), location.origin).pathname.match(/\/products\/[^\/]+/);
    return m ? m[0] : null;
  }

  function findColorOption(product) {
    var options = product.options || [];
    for (var i = 0; i < options.length; i++) {
      var o = options[i];
      var name = typeof o === 'string' ? o : o.name;
      if (/colou?r/i.test(name || '')) {
        return {
          name: name,
          position: (o && o.position) || i + 1,
          values: (o && o.values) || null
        };
      }
    }
    return null;
  }

  function valuesOf(product, colorOption) {
    if (colorOption.values) return colorOption.values;
    var seen = [];
    (product.variants || []).forEach(function (v) {
      var val = v['option' + colorOption.position];
      if (val && seen.indexOf(val) === -1) seen.push(val);
    });
    return seen;
  }

  function variantFor(product, position, value) {
    var found = null;
    var variants = product.variants || [];
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v['option' + position] !== value) continue;
      if (!found) found = v;
      if (v.available) { found = v; break; }
    }
    return found;
  }

  function sized(src) {
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=900';
  }

  function buildSwatch(path, value, variant) {
    var a = document.createElement('a');
    a.className = 'card-color-swatch' + (variant && !variant.available ? ' card-color-swatch--sold-out' : '');
    a.title = value;
    a.setAttribute('aria-label', value);
    a.href = variant ? path + '?variant=' + variant.id : path;

    if (variant) {
      // same attributes the Liquid swatches use, so the existing click handler swaps the card image
      a.setAttribute('data-card-swatch', '');
      a.setAttribute('data-variant-id', variant.id);
      a.setAttribute('data-variant-url', path + '?variant=' + variant.id);
      var img = variant.featured_image && variant.featured_image.src;
      if (img) a.setAttribute('data-variant-image', sized(img));
    }

    var dot = document.createElement('span');
    dot.className = 'card-color-swatch__color';
    dot.style.backgroundColor = colorFor(value);
    a.appendChild(dot);

    var label = document.createElement('span');
    label.className = 'visually-hidden';
    label.textContent = value;
    a.appendChild(label);
    return a;
  }

  function process(card) {
    if (card.dataset.csFallback) return;
    if (card.querySelector('.card-color-swatches')) { card.dataset.csFallback = 'liquid'; return; }

    var price = card.querySelector('.card__information .price');
    var path = productPath(card);
    if (!price || !path) return;
    card.dataset.csFallback = 'pending';

    loadProduct(path).then(function (product) {
      if (!product || card.querySelector('.card-color-swatches')) { card.dataset.csFallback = 'done'; return; }
      var opt = findColorOption(product);
      if (!opt) { card.dataset.csFallback = 'done'; return; }
      var values = valuesOf(product, opt);
      if (values.length < 2) { card.dataset.csFallback = 'done'; return; }

      var wrap = document.createElement('div');
      wrap.className = 'card-color-swatches';
      wrap.setAttribute('aria-label', 'Available colors');

      values.slice(0, MAX_SWATCHES).forEach(function (value) {
        wrap.appendChild(buildSwatch(path, value, variantFor(product, opt.position, value)));
      });

      var more = values.length - MAX_SWATCHES;
      if (more > 0) {
        var m = document.createElement('a');
        m.className = 'card-color-swatches__more';
        m.href = path;
        m.setAttribute('aria-label', 'View ' + more + ' more colors');
        m.textContent = '+' + more;
        wrap.appendChild(m);
      }

      price.insertAdjacentElement('afterend', wrap);
      card.dataset.csFallback = 'done';
    });
  }

  function scan() {
    document.querySelectorAll('.card-wrapper').forEach(process);
  }

  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(scan, 120);
  }

  function start() {
    scan();
    // collection filters / sorting / "load more" replace the grid with new cards
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
